/*
 * Resilia stat counter — counts each number up from 0 the first time its section scrolls into view.
 * The final value is already in the HTML, so nothing is lost if this never runs.
 */
(() => {
  // "2,000+" -> { prefix: '', target: 2000, suffix: '+', decimals: 0 }
  const parse = (raw) => {
    const match = raw.trim().match(/^(\D*)([\d.,]+)(.*)$/);
    if (!match) return null;
    const numeric = match[2].replace(/,/g, '');
    const target = parseFloat(numeric);
    if (Number.isNaN(target)) return null;
    return {
      prefix: match[1],
      suffix: match[3],
      target,
      decimals: numeric.includes('.') ? numeric.split('.')[1].length : 0,
      grouped: match[2].includes(','),
    };
  };

  const format = (value, { decimals, grouped }) =>
    grouped || decimals
      ? value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
      : String(Math.round(value));

  const animate = (el, stat) => {
    const duration = stat.target <= 100 ? 1000 : 1800;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - progress) * (1 - progress);
      el.textContent = stat.prefix + format(eased * stat.target, stat) + stat.suffix;
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.querySelectorAll('[data-rn-count]').forEach((el) => {
          const stat = parse(el.dataset.rnCount);
          if (stat) animate(el, stat);
        });
      });
    },
    { threshold: 0.3 }
  );

  const init = () => {
    document.querySelectorAll('[data-rn-count-group]:not([data-rn-count-ready])').forEach((group) => {
      group.dataset.rnCountReady = 'true';
      // Only reset to 0 when the section is still off-screen, so nothing visible flashes.
      const rect = group.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        group.querySelectorAll('[data-rn-count]').forEach((el) => {
          const stat = parse(el.dataset.rnCount);
          if (stat) el.textContent = stat.prefix + format(0, stat) + stat.suffix;
        });
        observer.observe(group);
      }
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
